/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { WebhookEventTypeInfo } from "./WebhookEventTypeInfo";
import {
  WebhookEventTypeInfoFromJSON,
  WebhookEventTypeInfoFromJSONTyped,
  WebhookEventTypeInfoToJSON,
  WebhookEventTypeInfoToJSONTyped,
} from "./WebhookEventTypeInfo";
import type { CompanyWebhookStatus } from "./CompanyWebhookStatus";
import {
  CompanyWebhookStatusFromJSON,
  CompanyWebhookStatusFromJSONTyped,
  CompanyWebhookStatusToJSON,
  CompanyWebhookStatusToJSONTyped,
} from "./CompanyWebhookStatus";

/**
 *
 * @export
 * @interface CompanyWebhookResponse
 */
export interface CompanyWebhookResponse {
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookResponse
   */
  companyWebhookId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookResponse
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookResponse
   */
  webhookUrl: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyWebhookResponse
   */
  subscribeToAllEvents?: boolean | null;
  /**
   *
   * @type {Array<WebhookEventTypeInfo>}
   * @memberof CompanyWebhookResponse
   */
  eventTypes?: Array<WebhookEventTypeInfo> | null;
  /**
   *
   * @type {CompanyWebhookStatus}
   * @memberof CompanyWebhookResponse
   */
  status: CompanyWebhookStatus;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookResponse
   */
  secretKeySuffix?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookResponse
   */
  description?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyWebhookResponse
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyWebhookResponse
   */
  updatedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookResponse
   */
  createdBy?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyWebhookResponse
   */
  lastTriggeredAt?: OffsetDateTime | null;
  /**
   *
   * @type {number}
   * @memberof CompanyWebhookResponse
   */
  failureCount?: number | null;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookResponse
   */
  requestHeaders: string;
}

/**
 * Check if a given object implements the CompanyWebhookResponse interface.
 */
export function instanceOfCompanyWebhookResponse(
  value: object,
): value is CompanyWebhookResponse {
  if (!("companyWebhookId" in value) || value["companyWebhookId"] === undefined)
    return false;
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("webhookUrl" in value) || value["webhookUrl"] === undefined)
    return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("requestHeaders" in value) || value["requestHeaders"] === undefined)
    return false;
  return true;
}

export function CompanyWebhookResponseFromJSON(
  json: any,
): CompanyWebhookResponse {
  return CompanyWebhookResponseFromJSONTyped(json, false);
}

export function CompanyWebhookResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookResponse {
  if (json == null) {
    return json;
  }
  return {
    companyWebhookId: json["companyWebhookId"],
    companyId: json["companyId"],
    webhookUrl: json["webhookUrl"],
    subscribeToAllEvents:
      json["subscribeToAllEvents"] == null
        ? undefined
        : json["subscribeToAllEvents"],
    eventTypes:
      json["eventTypes"] == null
        ? undefined
        : (json["eventTypes"] as Array<any>).map(WebhookEventTypeInfoFromJSON),
    status: CompanyWebhookStatusFromJSON(json["status"]),
    secretKeySuffix:
      json["secretKeySuffix"] == null ? undefined : json["secretKeySuffix"],
    description: json["description"] == null ? undefined : json["description"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    lastTriggeredAt:
      json["lastTriggeredAt"] == null ? undefined : json["lastTriggeredAt"],
    failureCount:
      json["failureCount"] == null ? undefined : json["failureCount"],
    requestHeaders: json["requestHeaders"],
  };
}

export function CompanyWebhookResponseToJSON(
  json: any,
): CompanyWebhookResponse {
  return CompanyWebhookResponseToJSONTyped(json, false);
}

export function CompanyWebhookResponseToJSONTyped(
  value?: CompanyWebhookResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyWebhookId: value["companyWebhookId"],
    companyId: value["companyId"],
    webhookUrl: value["webhookUrl"],
    subscribeToAllEvents: value["subscribeToAllEvents"],
    eventTypes:
      value["eventTypes"] == null
        ? undefined
        : (value["eventTypes"] as Array<any>).map(WebhookEventTypeInfoToJSON),
    status: CompanyWebhookStatusToJSON(value["status"]),
    secretKeySuffix: value["secretKeySuffix"],
    description: value["description"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
    createdBy: value["createdBy"],
    lastTriggeredAt: value["lastTriggeredAt"],
    failureCount: value["failureCount"],
    requestHeaders: value["requestHeaders"],
  };
}
